// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
* {
    border: 0;
    box-sizing: border-box;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-smoothing: antialiased;
    margin: 0;
    outline: 0;
    padding: 0;
    text-decoration: none;
    text-rendering: optimizeLegibility;
}

a {
    color: #4A5FD4;
    text-decoration: underline;
}

.container {
    text-align: center;
    font-size: 1.25rem;
    color: #000000;
    margin: 0 auto;
    padding: 0 96px;
}

.page {
    padding-top: 160px;
}

/* Header */
@keyframes bars {
    from {
        top: -100%;
        height: 100%;
    }
    50% {
        height: 100%;
    }
    to {
        top: 100%;
        height: 0;
    }
}

@keyframes fadeIn {
    from {
    opacity: 0;
  }

  25% {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeInText {
    from {
    opacity: 0;
    transform: translate3d(0, 20%, 0);
  }

  25% {
    opacity: 0;
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fadeInLink {
    from {
        opacity: 0;
        transform: translate3d(0, 20%, 0);
    }

    25% {
        opacity: 0;
    }

    to {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }
}

.mobile-show {
    display: none;
}

.logo-container {
    line-height: 0;
    display: block;
}



/* Footer */
.App-footer {
    max-width: 1472px;
    margin: 0 auto;
    width: 100%;
    padding: 24px 0;
    font-size: 14px;
}

.App-link {
    color: #000000;
}




/* Body */
.intro {
    font-size: 40px;
    line-height: 56px;
    font-weight: normal;
    text-align: left;
    max-width: 720px;
    margin-bottom: 120px;
    animation: fadeInText 0.5s linear forwards;
}

.grid-item {
    text-align: left;
    animation: fadeIn 0.5s linear forwards;
}

.grid-item .image-container {
    position: relative;
    overflow: hidden;
}

.grid-item .overlay {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    height: 100%;
    transition: 0.2s;
    background: rgba(0, 0, 0, 0.65);
    display: flex;
    flex-direction: column;
    justify-content: center;
}

@media(hover: hover) and (pointer: fine) {
    .grid-item:hover .overlay {
        top: 0;
        left: 0;
        opacity: 1;
        cursor: pointer;
    }
}

.grid-item .overlay span {
    color: white;
    font-size: 24px;
    font-weight: 700;
    margin: 0 auto;
    padding: 0;
}

.grid-item .label {
    padding: 12px 0;
    display: inline-block;
    color: black;
    font-size: 1.25rem;
}

.grid {
    display: grid;
    grid-template-columns: calc(50% - 8px) calc(50% - 8px);
    grid-template-rows: 1fr;
    grid-column-gap: 8px;
    column-gap: 8px;
    grid-row-gap: 8px;
    row-gap: 8px;
    margin-bottom: 96px;
}

.grid img {
    max-width: 100%;
    height: auto;
    display: block;
}

.overlay {
    position: fixed;
    top: 0;
    height: 100%;
    width: 100%;
    display: block;
    text-align: center;
    background: rgba(0, 0, 0, 0.7);
    left: 0;
    z-index: 99;
}

.overlay iframe {
    margin: 0 auto;
    max-width: 100%;
}

.overlay.hide {
    display: none;
}
.overlay.show {
    display: block;
}

.modal {
    font-size: 48px;
    color: black;
    background: white;
    margin: 0 auto;
    font-weight: 700;
    width: 100%;
}

.modal .modal-header {
    background: #F2EA5E;
    padding: 20px 24px;
    margin-bottom: 16px;
}

.modal span, .modal a {
    display: block;
}

.modal .modal-item {
    margin-bottom: 16px;
    padding: 12px 32px;
    text-align: left;
}

.modal span {
    font-size: 20px;
    font-weight: 900;
    text-align: left;
    margin-bottom: 16px;
}

.modal a {
    color: black;
    font-size: 20px;
    text-align: left;
    padding: 8px 0;
    text-decoration: none;
    font-weight: 300;
}

.preview-alert {
    background: #F2EA5E;
    padding: 20px 24px;
    color: black;
    font-weight: 700;
    font-size: 48px;
}

/* jOBS */
ul.jobs-list {
    list-style: none;
    text-align: left;
}
ul.jobs-list li {
    border-top: 2px solid #D8DCE1;
    padding: 40px 0;
    font-size: 24px;
    animation: fadeInText 0.5s linear forwards;
}
ul.jobs-list .right {
    float: right;
}

/* Project */
.section {
    display: grid;
    grid-template-columns: 55% 35%;
    grid-gap: 10%;
    margin-bottom: 160px;
}
.section-credits {
    display: grid;
    grid-template-columns: 33% 66%;
    margin-bottom: 160px;
}
.section-images {
    display: grid;
    grid-template-columns: calc(50% - 4px) calc(50% - 4px);
    grid-gap: 8px;
    margin-bottom: 160px;
}
.section-grid-images {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 8px;
    margin-bottom: 160px;
}
.section-image-full {
    margin-bottom: 4px;
}
.section-image-full img {
    width: 100%;
    height: auto;
}
.section-images img, .section-video img {
    width: 100%;
    height: auto;
}

.grid-half {
    display: grid;
    grid-template-columns: calc(50% - 4px) calc(50% - 4px);
    grid-gap: 8px
}
.grid-third {
    display: grid;
    grid-template-columns: calc(33% - 4px) calc(33% - 4px) calc(33% - 4px);
    grid-gap: 8px;
}
.section h2, .section-credits h2 {
    text-align: left;
    font-size: 24px;
    margin-bottom: 16px;
}
.section p, .section-contact p {
    font-size: 24px;
    line-height: 40px;
    text-align: left;
    margin-bottom: 40px;
}
.section-video {
    margin-bottom: 160px;
}
.list-credits {
    list-style: none;
    text-align: left;
}
.list-credits li {
    margin: 16px 0;
    display: grid;
    grid-template-columns: 40% 55%;
    grid-column-gap: 5%;
}

.iframe-wrapper {
    padding: 56.25% 0 0 0;
    position: relative;
}

.iframe {
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:100%;
}

.grid-credits {
    display: grid;
    grid-gap: 32px;
    grid-template-columns: calc(50% - 16px) calc(50%  - 16px);
    text-align: left;
    margin-top: 40px;
}

.grid-credits ul {
    list-style: none;
    margin-bottom: 56px;
}

.grid-credits ul li {
    margin-bottom: 16px;
}

.grid-credits ul li:first-child {
    font-weight: 600;
}

.grid-stacked {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 8px;
}

.jerks1 {
    height: 400px;
    background-size: contain;
    background-repeat: no-repeat;
    background-color: #FE3685;
    background-position: center;
}

.jerks2 {
    height: 400px;
    background-size: contain;
    background-repeat: no-repeat;
    background-color: #000000;
    background-position: center;
}

.jerks3 {
    height: 400px;
    display: inline-block;
    background-position: center;
    background-size: cover;
}

.james {
    background-size: cover;
    background-repeat: no-repeat;
    background-color: #000000;
    background-position: center;
}

.vince, .michael {
    height: 400px;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: #000000;
    background-position: center;
}

.section-contact {
    display: grid;
    grid-template-columns: 50% 45%;
    grid-gap: 5%;
    margin-bottom: 160px;
}
.contact-image {
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    display: block;
    height: 400px;
}

@media screen and (max-width: 1200px){
    .section .jerks3 {
        height: 220px;
        width: 100%;
        background-size: contain;
    }
    .section p, .section-contact p {
        font-size: 20px;
        line-height: 36px;
    }
    .section, .section-contact {
        margin-bottom: 120px;
    }
    .grid-third .jerks3, .vince, .michael {
        height: 240px;
    }
    .jerks1, .jerks2 {
        height: 240px;
    }
    .section-credits {
        margin-bottom: 80px;
    }
    .section-grid-images {
        margin-bottom: 80px;
    }
}

@media screen and (max-width: 1080px){
   .section, .section-contact {
        display: block;
   }
}

@media screen and (max-width: 1000px){
    .container {
        padding: 0px 64px;
    }
}

@media screen and (max-width: 960px){
    .intro {
        font-size: 32px;
        line-height: 48px;
        max-width: 560px;
        margin-bottom: 80px;
    }
    .section-video {
        margin-bottom: 80px;
    }
    .section p, .section-contact p {
        font-size: 20px;
        line-height: 36px;
    }
    .section, .section-contact {
        margin-bottom: 80px;
    }
    .section-images {
        grid-template-columns: 100%;
        margin-bottom: 80px;
    }
    .App-header ul li {
        font-size: 20px;
        margin-bottom: 28px;
    }
    .section-credits {
        display: block;
        margin-bottom: 80px;
    }
}

@media screen and (max-width: 880px){
    .App-header {
        position: relative;
        height: auto;
        width: 100%;
        z-index: 99;
        text-align: left;
    }
    .mobile-hide {
        display: none;
    }
    .mobile-show {
        display: block;
    }
}

@media screen and (max-width: 720px){
   .section .jerks3 {
       height: 200px;
   }
   ul.jobs-list li {
       padding: 32px 0;
       font-size: 20px;
   }
}

@media screen and (max-width: 560px){
   .section .jerks3 {
        height: 300px;
        width: 100%;
        background-size: contain;
        background-repeat: no-repeat;
        background-color: #FFF54D;
   }
   .jerks1, .jerks2 {
       height: 300px;
    }
    .james {
        height: 300px;
        background-position-y: 0;
    }
    .grid-third, .grid-half, .grid-credits {
        grid-template-columns: 100%;
    }
    .grid-third .jerks3, .vince, .michael {
        height: 300px;
        background-position-y: 0;
    }
    .grid-third .jerks3 {
        background-size: contain;
        background-repeat: no-repeat;
        background-color: #FFF54D;
        background-position: center;
    }
}

@media screen and (max-width: 448px){
    .container {
        padding: 0 48px;
    }
}

@media screen and (max-width: 992px){
   .grid{
        grid-template-columns: repeat(1, 1fr);
        margin: 0 auto;
        max-width: 528px;
        padding: 0;
   }
}

@media screen and (max-width: 600px){
    .grid {
        grid-column-gap: 16px;
        column-gap: 16px;
        grid-row-gap: 16px;
        row-gap: 16px;
    }
    .App-header button {
        font-size: 1rem;
        right: 24px;
        font-weight: 600;
        top: 16px;
    }
    .modal {
        padding-bottom: 16px;
    }
    .modal .modal-header {
        font-size: 2rem;
        padding: 16px;
    }
    ul.jobs-list li {
        padding: 24px 0;
    }
    ul.jobs-list li .right {
        display: none;
    }
}
@media screen and (max-width: 400px){
    .intro {
        font-size: 28px;
        line-height: 44px;
    }
    .section h2, .section-contact h2 {
        font-size: 20px;
    }
    .section p, .section-contact p {
        font-size: 17px;
        line-height: 28px;
    }
    .list-credits li, .grid-credits li {
        margin: 12px 0;
        font-size: 17px;
    }
    .grid-credits ul {
        margin-bottom: 32px;
    }
    .grid-credits {
        grid-gap: 0;
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":";AACA;IACI,SAAS;IACT,sBAAsB;IACtB,kCAAkC;IAClC,mCAAmC;IACnC,2BAA2B;IAC3B,SAAS;IACT,UAAU;IACV,UAAU;IACV,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA,WAAW;AACX;IACI;QACI,UAAU;QACV,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,SAAS;QACT,SAAS;IACb;AACJ;;AAEA;IACI;IACA,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;IACI;IACA,UAAU;IAEV,iCAAiC;EACnC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IAEV,+BAA+B;EACjC;AACF;;AAEA;IACI;QACI,UAAU;QAEV,iCAAiC;IACrC;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;QAEV,+BAA+B;IACnC;AACJ;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;;;AAIA,WAAW;AACX;IACI,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;;;;AAKA,SAAS;AACT;IACI,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI;QACI,MAAM;QACN,OAAO;QACP,UAAU;QACV,eAAe;IACnB;AACJ;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sDAAsD;IACtD,uBAAuB;IACvB,oBAAoB;IACpB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,YAAY;IACZ,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,8BAA8B;IAC9B,OAAO;IACP,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA,SAAS;AACT;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,6BAA6B;IAC7B,eAAe;IACf,eAAe;IACf,0CAA0C;AAC9C;AACA;IACI,YAAY;AAChB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,sDAAsD;IACtD,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,2BAA2B;IAC3B,aAAa;IACb,oBAAoB;AACxB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sDAAsD;IACtD;AACJ;AACA;IACI,aAAa;IACb,sEAAsE;IACtE,aAAa;AACjB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,KAAK;IACL,MAAM;IACN,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;IACb,cAAc;IACd,yDAAyD;IACzD,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,4BAA4B;IAC5B,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,wBAAwB;IACxB,4BAA4B;IAC5B,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,cAAc;IACd,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;QACb,WAAW;QACX,wBAAwB;IAC5B;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,oBAAoB;IACxB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;IACjB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;AACJ;;AAEA;GACG;QACK,cAAc;GACnB;AACH;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,2BAA2B;QAC3B,mBAAmB;IACvB;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,cAAc;QACd,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,aAAa;IACjB;IACA;QACI,cAAc;IAClB;AACJ;;AAEA;GACG;OACI,aAAa;GACjB;GACA;OACI,eAAe;OACf,eAAe;GACnB;AACH;;AAEA;GACG;QACK,aAAa;QACb,WAAW;QACX,wBAAwB;QACxB,4BAA4B;QAC5B,yBAAyB;GAC9B;GACA;OACI,aAAa;IAChB;IACA;QACI,aAAa;QACb,wBAAwB;IAC5B;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,aAAa;QACb,wBAAwB;IAC5B;IACA;QACI,wBAAwB;QACxB,4BAA4B;QAC5B,yBAAyB;QACzB,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;GACG;QACK,qCAAqC;QACrC,cAAc;QACd,gBAAgB;QAChB,UAAU;GACf;AACH;;AAEA;IACI;QACI,qBAAqB;QACrB,gBAAgB;QAChB,kBAAkB;QAClB,aAAa;IACjB;IACA;QACI,eAAe;QACf,WAAW;QACX,gBAAgB;QAChB,SAAS;IACb;IACA;QACI,oBAAoB;IACxB;IACA;QACI,eAAe;QACf,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,cAAc;QACd,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,WAAW;IACf;AACJ","sourcesContent":["\n* {\n    border: 0;\n    box-sizing: border-box;\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    font-smoothing: antialiased;\n    margin: 0;\n    outline: 0;\n    padding: 0;\n    text-decoration: none;\n    text-rendering: optimizeLegibility;\n}\n\na {\n    color: #4A5FD4;\n    text-decoration: underline;\n}\n\n.container {\n    text-align: center;\n    font-size: 1.25rem;\n    color: #000000;\n    margin: 0 auto;\n    padding: 0 96px;\n}\n\n.page {\n    padding-top: 160px;\n}\n\n/* Header */\n@keyframes bars {\n    from {\n        top: -100%;\n        height: 100%;\n    }\n    50% {\n        height: 100%;\n    }\n    to {\n        top: 100%;\n        height: 0;\n    }\n}\n\n@keyframes fadeIn {\n    from {\n    opacity: 0;\n  }\n\n  25% {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeInText {\n    from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 20%, 0);\n    transform: translate3d(0, 20%, 0);\n  }\n\n  25% {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes fadeInLink {\n    from {\n        opacity: 0;\n        -webkit-transform: translate3d(0, 20%, 0);\n        transform: translate3d(0, 20%, 0);\n    }\n\n    25% {\n        opacity: 0;\n    }\n\n    to {\n        opacity: 1;\n        -webkit-transform: translate3d(0, 0, 0);\n        transform: translate3d(0, 0, 0);\n    }\n}\n\n.mobile-show {\n    display: none;\n}\n\n.logo-container {\n    line-height: 0;\n    display: block;\n}\n\n\n\n/* Footer */\n.App-footer {\n    max-width: 1472px;\n    margin: 0 auto;\n    width: 100%;\n    padding: 24px 0;\n    font-size: 14px;\n}\n\n.App-link {\n    color: #000000;\n}\n\n\n\n\n/* Body */\n.intro {\n    font-size: 40px;\n    line-height: 56px;\n    font-weight: normal;\n    text-align: left;\n    max-width: 720px;\n    margin-bottom: 120px;\n    animation: fadeInText 0.5s linear forwards;\n}\n\n.grid-item {\n    text-align: left;\n    animation: fadeIn 0.5s linear forwards;\n}\n\n.grid-item .image-container {\n    position: relative;\n    overflow: hidden;\n}\n\n.grid-item .overlay {\n    width: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n    opacity: 0;\n    height: 100%;\n    transition: 0.2s;\n    background: rgba(0, 0, 0, 0.65);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n}\n\n@media(hover: hover) and (pointer: fine) {\n    .grid-item:hover .overlay {\n        top: 0;\n        left: 0;\n        opacity: 1;\n        cursor: pointer;\n    }\n}\n\n.grid-item .overlay span {\n    color: white;\n    font-size: 24px;\n    font-weight: 700;\n    margin: 0 auto;\n    padding: 0;\n}\n\n.grid-item .label {\n    padding: 12px 0;\n    display: inline-block;\n    color: black;\n    font-size: 1.25rem;\n}\n\n.grid {\n    display: grid;\n    grid-template-columns: calc(50% - 8px) calc(50% - 8px);\n    grid-template-rows: 1fr;\n    grid-column-gap: 8px;\n    column-gap: 8px;\n    grid-row-gap: 8px;\n    row-gap: 8px;\n    margin-bottom: 96px;\n}\n\n.grid img {\n    max-width: 100%;\n    height: auto;\n    display: block;\n}\n\n.overlay {\n    position: fixed;\n    top: 0;\n    height: 100%;\n    width: 100%;\n    display: block;\n    text-align: center;\n    background: rgba(0, 0, 0, 0.7);\n    left: 0;\n    z-index: 99;\n}\n\n.overlay iframe {\n    margin: 0 auto;\n    max-width: 100%;\n}\n\n.overlay.hide {\n    display: none;\n}\n.overlay.show {\n    display: block;\n}\n\n.modal {\n    font-size: 48px;\n    color: black;\n    background: white;\n    margin: 0 auto;\n    font-weight: 700;\n    width: 100%;\n}\n\n.modal .modal-header {\n    background: #F2EA5E;\n    padding: 20px 24px;\n    margin-bottom: 16px;\n}\n\n.modal span, .modal a {\n    display: block;\n}\n\n.modal .modal-item {\n    margin-bottom: 16px;\n    padding: 12px 32px;\n    text-align: left;\n}\n\n.modal span {\n    font-size: 20px;\n    font-weight: 900;\n    text-align: left;\n    margin-bottom: 16px;\n}\n\n.modal a {\n    color: black;\n    font-size: 20px;\n    text-align: left;\n    padding: 8px 0;\n    text-decoration: none;\n    font-weight: 300;\n}\n\n.preview-alert {\n    background: #F2EA5E;\n    padding: 20px 24px;\n    color: black;\n    font-weight: 700;\n    font-size: 48px;\n}\n\n/* jOBS */\nul.jobs-list {\n    list-style: none;\n    text-align: left;\n}\nul.jobs-list li {\n    border-top: 2px solid #D8DCE1;\n    padding: 40px 0;\n    font-size: 24px;\n    animation: fadeInText 0.5s linear forwards;\n}\nul.jobs-list .right {\n    float: right;\n}\n\n/* Project */\n.section {\n    display: grid;\n    grid-template-columns: 55% 35%;\n    grid-gap: 10%;\n    margin-bottom: 160px;\n}\n.section-credits {\n    display: grid;\n    grid-template-columns: 33% 66%;\n    margin-bottom: 160px;\n}\n.section-images {\n    display: grid;\n    grid-template-columns: calc(50% - 4px) calc(50% - 4px);\n    grid-gap: 8px;\n    margin-bottom: 160px;\n}\n.section-grid-images {\n    display: grid;\n    grid-template-columns: 100%;\n    grid-gap: 8px;\n    margin-bottom: 160px;\n}\n.section-image-full {\n    margin-bottom: 4px;\n}\n.section-image-full img {\n    width: 100%;\n    height: auto;\n}\n.section-images img, .section-video img {\n    width: 100%;\n    height: auto;\n}\n\n.grid-half {\n    display: grid;\n    grid-template-columns: calc(50% - 4px) calc(50% - 4px);\n    grid-gap: 8px\n}\n.grid-third {\n    display: grid;\n    grid-template-columns: calc(33% - 4px) calc(33% - 4px) calc(33% - 4px);\n    grid-gap: 8px;\n}\n.section h2, .section-credits h2 {\n    text-align: left;\n    font-size: 24px;\n    margin-bottom: 16px;\n}\n.section p, .section-contact p {\n    font-size: 24px;\n    line-height: 40px;\n    text-align: left;\n    margin-bottom: 40px;\n}\n.section-video {\n    margin-bottom: 160px;\n}\n.list-credits {\n    list-style: none;\n    text-align: left;\n}\n.list-credits li {\n    margin: 16px 0;\n    display: grid;\n    grid-template-columns: 40% 55%;\n    grid-column-gap: 5%;\n}\n\n.iframe-wrapper {\n    padding: 56.25% 0 0 0;\n    position: relative;\n}\n\n.iframe {\n    position:absolute;\n    top:0;\n    left:0;\n    width:100%;\n    height:100%;\n}\n\n.grid-credits {\n    display: grid;\n    grid-gap: 32px;\n    grid-template-columns: calc(50% - 16px) calc(50%  - 16px);\n    text-align: left;\n    margin-top: 40px;\n}\n\n.grid-credits ul {\n    list-style: none;\n    margin-bottom: 56px;\n}\n\n.grid-credits ul li {\n    margin-bottom: 16px;\n}\n\n.grid-credits ul li:first-child {\n    font-weight: 600;\n}\n\n.grid-stacked {\n    display: grid;\n    grid-template-columns: 100%;\n    grid-gap: 8px;\n}\n\n.jerks1 {\n    height: 400px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-color: #FE3685;\n    background-position: center;\n}\n\n.jerks2 {\n    height: 400px;\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-color: #000000;\n    background-position: center;\n}\n\n.jerks3 {\n    height: 400px;\n    display: inline-block;\n    background-position: center;\n    background-size: cover;\n}\n\n.james {\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-color: #000000;\n    background-position: center;\n}\n\n.vince, .michael {\n    height: 400px;\n    background-size: cover;\n    background-repeat: no-repeat;\n    background-color: #000000;\n    background-position: center;\n}\n\n.section-contact {\n    display: grid;\n    grid-template-columns: 50% 45%;\n    grid-gap: 5%;\n    margin-bottom: 160px;\n}\n.contact-image {\n    background-size: contain;\n    background-repeat: no-repeat;\n    background-position: center;\n    display: block;\n    height: 400px;\n}\n\n@media screen and (max-width: 1200px){\n    .section .jerks3 {\n        height: 220px;\n        width: 100%;\n        background-size: contain;\n    }\n    .section p, .section-contact p {\n        font-size: 20px;\n        line-height: 36px;\n    }\n    .section, .section-contact {\n        margin-bottom: 120px;\n    }\n    .grid-third .jerks3, .vince, .michael {\n        height: 240px;\n    }\n    .jerks1, .jerks2 {\n        height: 240px;\n    }\n    .section-credits {\n        margin-bottom: 80px;\n    }\n    .section-grid-images {\n        margin-bottom: 80px;\n    }\n}\n\n@media screen and (max-width: 1080px){\n   .section, .section-contact {\n        display: block;\n   }\n}\n\n@media screen and (max-width: 1000px){\n    .container {\n        padding: 0px 64px;\n    }\n}\n\n@media screen and (max-width: 960px){\n    .intro {\n        font-size: 32px;\n        line-height: 48px;\n        max-width: 560px;\n        margin-bottom: 80px;\n    }\n    .section-video {\n        margin-bottom: 80px;\n    }\n    .section p, .section-contact p {\n        font-size: 20px;\n        line-height: 36px;\n    }\n    .section, .section-contact {\n        margin-bottom: 80px;\n    }\n    .section-images {\n        grid-template-columns: 100%;\n        margin-bottom: 80px;\n    }\n    .App-header ul li {\n        font-size: 20px;\n        margin-bottom: 28px;\n    }\n    .section-credits {\n        display: block;\n        margin-bottom: 80px;\n    }\n}\n\n@media screen and (max-width: 880px){\n    .App-header {\n        position: relative;\n        height: auto;\n        width: 100%;\n        z-index: 99;\n        text-align: left;\n    }\n    .mobile-hide {\n        display: none;\n    }\n    .mobile-show {\n        display: block;\n    }\n}\n\n@media screen and (max-width: 720px){\n   .section .jerks3 {\n       height: 200px;\n   }\n   ul.jobs-list li {\n       padding: 32px 0;\n       font-size: 20px;\n   }\n}\n\n@media screen and (max-width: 560px){\n   .section .jerks3 {\n        height: 300px;\n        width: 100%;\n        background-size: contain;\n        background-repeat: no-repeat;\n        background-color: #FFF54D;\n   }\n   .jerks1, .jerks2 {\n       height: 300px;\n    }\n    .james {\n        height: 300px;\n        background-position-y: 0;\n    }\n    .grid-third, .grid-half, .grid-credits {\n        grid-template-columns: 100%;\n    }\n    .grid-third .jerks3, .vince, .michael {\n        height: 300px;\n        background-position-y: 0;\n    }\n    .grid-third .jerks3 {\n        background-size: contain;\n        background-repeat: no-repeat;\n        background-color: #FFF54D;\n        background-position: center;\n    }\n}\n\n@media screen and (max-width: 448px){\n    .container {\n        padding: 0 48px;\n    }\n}\n\n@media screen and (max-width: 992px){\n   .grid{\n        grid-template-columns: repeat(1, 1fr);\n        margin: 0 auto;\n        max-width: 528px;\n        padding: 0;\n   }\n}\n\n@media screen and (max-width: 600px){\n    .grid {\n        grid-column-gap: 16px;\n        column-gap: 16px;\n        grid-row-gap: 16px;\n        row-gap: 16px;\n    }\n    .App-header button {\n        font-size: 1rem;\n        right: 24px;\n        font-weight: 600;\n        top: 16px;\n    }\n    .modal {\n        padding-bottom: 16px;\n    }\n    .modal .modal-header {\n        font-size: 2rem;\n        padding: 16px;\n    }\n    ul.jobs-list li {\n        padding: 24px 0;\n    }\n    ul.jobs-list li .right {\n        display: none;\n    }\n}\n@media screen and (max-width: 400px){\n    .intro {\n        font-size: 28px;\n        line-height: 44px;\n    }\n    .section h2, .section-contact h2 {\n        font-size: 20px;\n    }\n    .section p, .section-contact p {\n        font-size: 17px;\n        line-height: 28px;\n    }\n    .list-credits li, .grid-credits li {\n        margin: 12px 0;\n        font-size: 17px;\n    }\n    .grid-credits ul {\n        margin-bottom: 32px;\n    }\n    .grid-credits {\n        grid-gap: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
